import { TextButton } from "@/components/button/text-button";
import TextField from "@/components/form/hook-form/textfield";
import { useToast } from "@/hooks/ui/use-toast";
import { GoToFoodFormData } from "@/schemas/go-to-food-schema";
import { IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";
import { memo } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

export const MealGroupList = memo(function MealGroupList() {
  const { control, watch } = useFormContext<GoToFoodFormData>();
  const { fields, append, remove } = useFieldArray<
    GoToFoodFormData,
    "selectedMeals",
    "id"
  >({
    control,
    name: "selectedMeals",
  });
  const selectedMeals: { name: string }[] = watch("selectedMeals") ?? [];
  const { showInfo } = useToast();

  const onTextFieldBlur = (index: number) => {
    // At least show one meal textfield
    if (fields.length === 1) {
      return;
    }
    if (selectedMeals[index].name !== "") {
      return;
    }
    remove(index);
  };

  const handleAddMeal = () => {
    if (fields.length >= 3) {
      showInfo("Maximum 3 meals allowed");
      return;
    }
    append({ name: "" });
  };

  return (
    // ! Add key to make sure the component is rebuilt
    <div className="w-full gap-y-2 flex flex-col py-2">
      {fields.map((field, index) => (
        <TextField
          key={field.id}
          control={control}
          name={`selectedMeals.${index}.name`}
          placeholder="Please enter a meal name"
          onBlur={() => onTextFieldBlur(index)}
        />
      ))}
      <div className="flex justify-end">
        <TextButton onClick={handleAddMeal}>
          <IonIcon icon={add} className="text-lg" />
          Add Another
        </TextButton>
      </div>
    </div>
  );
});
